import { Dispatch, SetStateAction, useState } from "react";
import { VendedorActions } from "../../PanelActions/enums"; 
import { ErrorMessage } from "../../../../components/errors/ErrorMessage";
import { SelectCreateEmpresaForm } from "../../../../components/ui/SelectCreateEmpresaForm";
import { InputCreateEmpresaForm } from "../../../../components/ui/InputCreateEmpresaForm";
import { useForm } from "react-hook-form";
import { CreateVendedor } from "../../../../types/vendedor";
import { useCreateVendedorMutation } from "../../../../api/vendedorApi";
import { useAdminPanelUI } from "../../../../hooks/useAdminPanelUI";
import { ActionButtons } from "src/components/ui/ActionButtons";

const tipoVendedores = [{ id: 1, nombre: "Odontólogos" }, { id: 2, nombre: "Ejecutivos" }];

interface Props {
    setVendedorSelected: Dispatch<SetStateAction<number>>;
}

export function CreateVendedorForm({ setVendedorSelected }: Props) {
    const { setVendedorAction } = useAdminPanelUI();
    const [createVendedor, { isLoading }] = useCreateVendedorMutation();

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm<CreateVendedor>();

    const submit = handleSubmit(async (data) => {
        try {
            setErrorMessage(null);
            const response = await createVendedor(data).unwrap();
            setVendedorSelected(response.id);
            setVendedorAction(VendedorActions.VendedorDetails);
        } catch (error) {
            setErrorMessage("Hay un error");
        }
    });

    return (
        <div className="h-full w-full">
            <form onSubmit={submit} className="grid" autoComplete="off">

                <div className="flex gap-x-2">

                    <div className="w-fit m-3">
                        <p className="text-xl font-semibold">Informacion del vendedor</p>
                    </div>

                    <div>
                        <div className="flex gap-x-4 mt-2">
                            <div>
                                <InputCreateEmpresaForm
                                    height="h-[35px]"
                                    width="w-[300px]"
                                    label="Nombre"
                                    register={register("nombre", {
                                        required: "El nombre del usuario es requerido",
                                        maxLength: 50,
                                    })} />

                                <div className="h-[20px]">
                                    {errors.nombre?.type === "required" && (
                                        <p className="valErrorText text-sm">{errors.nombre.message}</p>
                                    )}
                                    {errors.nombre?.type === "maxLength" && (
                                        <p className="valErrorText text-sm">El número maximo de caracteres es 50</p>
                                    )}
                                </div>
                            </div>

                            <div>
                                <SelectCreateEmpresaForm
                                    height="h-[35px]"
                                    width="w-[300px]"
                                    label="Tipo de vendedor"
                                    register={register("tipo", {
                                        required: "El tipo del vendedor es requerido",
                                        min: 1,
                                    })}
                                    datos={tipoVendedores.map((tipo, index) => (
                                        <option key={index} value={tipo.id}>{tipo.nombre}</option>
                                    ))}/>
                                <div className="h-[20px]">
                                    {errors.tipo?.type === "required" && (
                                        <p className="valErrorText text-sm">{errors.tipo.message}</p>
                                    )}
                                    {errors.tipo?.type === "min" && (
                                        <p className="valErrorText text-sm">El tipo del vendedor es requerido</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {errorMessage && (
                    <div className="my-2">
                        <ErrorMessage
                            customMessage>
                            <p className="text-sm">{errorMessage}</p>
                        </ErrorMessage>
                    </div>
                )}

                <ActionButtons 
                    isLoading={isLoading}
                    saveButtonText="Guardar"
                    onCancel={()=> setVendedorAction(VendedorActions.VendedoresList)}/>
            </form>
        </div>
    );
}
